import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Product } from '@spartacus/core';
import { CmsComponentData, CurrentProductService } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { distinctUntilChanged, filter, switchMap, tap } from 'rxjs/operators';
import { ComponentService } from 'src/app/service/component.service';
import { ShimanoLanguageService } from 'src/app/service/language/shimano-language.service';
import { ManualsPayload, ManualsService } from 'src/app/service/manuals/manuals.service';

@Component({
  selector: 'app-product-manual',
  templateUrl: './product-manual.component.html',
  styleUrls: ['./product-manual.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ProductManualComponent implements OnInit {
  items$: Observable<any> = this.currentProductService.getProduct().pipe(
    filter(Boolean),
    distinctUntilChanged(),
    switchMap((product: Product) => {
      return this.getProductManuals(product.code).pipe(
        tap((productManual) => {
          this.componentService.setProductManual(productManual);
        })
      );
    })
  );

  private getProductManuals(code: string): Observable<any> {
    const manualsServicepayload: ManualsPayload = {
      fields: 'DEFAULT',
      productCode: code,
      productOptions: 'MANUALS',
    };
    return this.manualsService.getManuals(manualsServicepayload);
  }

  constructor(
    protected component: CmsComponentData<any>,
    protected currentProductService: CurrentProductService,
    private manualsService: ManualsService,
    private componentService: ComponentService,
    private languageService: ShimanoLanguageService
  ) {}

  get activeLanguage$(): Observable<string> {
    return this.languageService.getActive();
  }

  ngOnInit(): void {}
}
